import React from 'react';
import styled from 'styled-components';
import { Tooltip, TextArea, Dropdown, Input, Popover } from 'freemium-ui';
import { useFormContext } from 'react-hook-form';

import Icons from 'components/icons';

export type SurveySettingsProps = {
  componentName?: 'Survey' | 'Template';
};

export const SurveySettings = ({
  componentName = 'Survey',
}: SurveySettingsProps) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    register,
    formState: { errors },
    watch,
    getValues,
  } = useFormContext();

  const isActive = getValues().state === 'ACTIVE';

  return (
    <div>
      <div
        aria-describedby="basic-popover"
        onClick={(e: any) => setAnchorEl(e.currentTarget)}
      >
        <Tooltip label={`${componentName} settings`} position="left">
          <Icons glyph="settings-new" size="22" viewBox="-9 -8 26 26" />
        </Tooltip>
      </div>
      <Popover
        id="basic-popover"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <StyledDiv onClick={(e: any) => e.stopPropagation()}>
          <div className="content">
            <div className="header">{`${componentName} settings`}</div>

            <div className="field ">
              <label className="is-required" htmlFor="lowRating">
                Name
              </label>
              <Input
                inputStyle={{
                  minWidth: '110px',
                }}
                {...register('name')}
                maxLength={50}
                disabled={isActive}
                isErrored={Boolean(errors?.name)}
                errorText={errors?.name?.message}
                value={watch('name')}
              />
            </div>

            <div className="field ">
              <label className="is-required" htmlFor="lowRating">
                Description
              </label>
              <TextArea
                inputStyle={{
                  minWidth: '110px',
                  minHeight: '70px',
                }}
                rows={3}
                disabled={isActive}
                isErrored={!!errors?.desc}
                errorText={errors?.desc?.message}
                {...register('desc')}
                maxLength={300}
                value={watch('desc')}
              />
            </div>
            <div className="field ">
              <label className="is-required" htmlFor="lowRating">
                Language
              </label>
              <Dropdown
                defaultSelectedItem={{ id: 'en', text: 'English' }}
                items={[
                  { id: 'en', text: 'English' },
                  { id: 'fr', text: 'French' },
                ]}
                itemToString={(item: any) => (item ? item.text : '')}
                onChange={(item: any) => {}}
                disabled
              />
            </div>
          </div>
        </StyledDiv>
      </Popover>
    </div>
  );
};

export default SurveySettings;

export const StyledDiv = styled('div')`
  width: 350px;
  overflow: auto;
  max-height: 500px;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  margin-top: 10px;

  .header {
    background: #fff;
    padding: 20px 10px 20px 10px;
    font-size: 16px;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  [role='tablist'] {
    padding-top: 10px;
    box-shadow: 0px 2px 4px rgba(207, 215, 223, 0.3);
  }
  [role='tab'] {
    width: 50%;
    margin: 0 20px;
    text-align: center;
  }

  .block {
    display: block;
  }
  .mb-2 {
    margin-bottom: 16px;
  }
  .content {
    padding: 0 10px;

    .field {
      display: block;
      margin: 0 10px 30px 10px;

      &.inline {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .half {
        width: 50%;
        width: 150px;
      }

      .input-basic textarea:focus ~ .end-max-length {
        opacity: 1;
      }

      label {
        font-size: 13px;
        color: var(--color-smoke-700);
        & > div:last-child {
          margin-left: 8px;
        }
        &.is-required {
          display: inline-block;
          margin-bottom: 5px;
        }
      }

      .button-value.active {
        background: #fff;
        border-radius: 5px;
      }

      .button-value {
        font-size: 12px;
        font-weight: 600;
        padding: 2px 10px;
        cursor: pointer;
      }

      .button-menu {
        display: flex;
        align-items: center;
        padding: 3px;
        border-radius: 4px;
        background: var(--color-smoke-50);
      }
    }
  }
`;
